import React from 'react';
import { func, string } from 'prop-types';

import './PromoSidecarNav.scss';

export const PromoSidecarNav = ({ closeSidecar, closeDrawer, backText }) => {
  return (
    <nav className="promo-sidecar-nav">
      <button
        type="button"
        className="promo-sidecar-nav-back"
        data-testid="promo-sidecar-nav-back"
        onClick={closeSidecar}
      >
        <img src="https://assets.homedepot-static.com/images/v1/caret-orange.svg" alt="" />
        {backText}
      </button>
      <button
        type="button"
        className="promo-sidecar-nav-close"
        data-testid="promo-sidecar-nav-close"
        aria-label="Close Promotion Product Drawer"
        onClick={closeDrawer}
      />
    </nav>
  );
};

PromoSidecarNav.displayName = 'PromoSidecarNav';

PromoSidecarNav.propTypes = {
  closeSidecar: func.isRequired,
  closeDrawer: func.isRequired,
  backText: string.isRequired,
};
